import Layout from "../Layout";
import HeaderUser from "./HeaderUser";
import GcpUserList from "./GcpUserList";

const GcpUsers = () => (
  <Layout>
    <HeaderUser />
    <GcpUserList />
  </Layout>
);

export default GcpUsers;
